// Node's Buffer encodes in one pass. The hand-rolled fallback below builds the
// binary string chunk by chunk before btoa copies it again, so peak memory is
// roughly 4x the input instead of ~2.33x - which matters when the input is an
// email attachment inside a 512MB container.
const nodeBuffer = (
  globalThis as {
    Buffer?: { from(data: ArrayBuffer): { toString(encoding: string): string } }
  }
).Buffer

export async function blobToBase64(blob: Blob) {
  const arrayBuffer = await blob.arrayBuffer()

  if (nodeBuffer) return nodeBuffer.from(arrayBuffer).toString('base64')

  let binary = ''
  const bytes = new Uint8Array(arrayBuffer)
  const chunkSize = 0x8000 // handle large files safely: Maximum call stack size exceeded" errors that can occur when spreading too many bytes into String.fromCharCode()
  for (let i = 0; i < bytes.length; i += chunkSize) {
    binary += String.fromCharCode(...bytes.subarray(i, i + chunkSize))
  }

  return btoa(binary)
}
